export type PageContent = {
  heading: string;
  subHeading?: string;
  body?: string;
  formHeading?: string;
  formSubHeading?: string;
  formLegal?: string;
  submit?: string;
};

type CtaContent = {
  heading: string;
  link: string;
  linkText: string;
};

export type GlobalContent = {
  brandCta: CtaContent;
  artistCta: CtaContent;
  quote?: string;
  secondaryLogoUrl: string;
  videoUrl: string;
};

type StaticContent = {
  precampaign: PageContent;
  registration: PageContent;
  postRegistration: PageContent;
  postcampaign: PageContent;
  globalContent: GlobalContent;
};

export const staticContent: StaticContent = {
  precampaign: {
    heading: "Coming Soon",
  },
  registration: {
    heading: "The Brittney Spencer Flyaway Experience",
    formHeading: "Your chance to see<br />Brittney Spencer!",
    formLegal:
      '<a href="rules" target="_blank" rel="noopener noreferrer" class="uppercase">SWEEPSTAKES RULES</a>',
    formSubHeading:
      "Register for a chance to win a Flyaway Experience to see Brittney Spencer.",
    submit: "Register",
  },
  postRegistration: {
    heading: "You’ve<br />Registered!",
    subHeading: "Brittney Spencer and<br />the Ford F-150&reg;",
    body:
      "The winner will get a Flyaway Experience<br />to a Brittney Spencer concert!",
  },
  postcampaign: {
    heading: "Sorry you<br />missed it!",
    subHeading: "Brittney Spencer and<br />the Ford F-150&reg;",
    body: "Registration is closed for<br />this sweepstakes.",
  },
  globalContent: {
    brandCta: {
      heading: "Build the Ford F-150&reg;<br />you’ve always wanted",
      link: "https://local.ford.com/nashville-little-rock-memphis/",
      linkText: "Build & Price",
    },
    artistCta: {
      heading: `Brittney Spencer's featured<br />single, “Damn Good Life”`,
      link:
        "https://open.spotify.com/track/0OHd0l2dXa5HFbuw9pu6TU?si=1b6feeb0168746a6",
      linkText: "Listen",
    },
    quote:
      '“Ford just holds a special<br /><span class="brand-color">place in my heart.”</span>',
    secondaryLogoUrl: "https://www.fordmusic.com",
    videoUrl:
      "https://www.youtube.com/embed/_6FFqZw0_Oo?autoplay=0&cc_load_policy=1",
  },
};
